import React from 'react';

/**
 * Inline form-field error message.
 * Renders a small red alert with a warning icon, or nothing if no error.
 * Used across all forms in the app — keeps UX consistent.
 */
const FieldError = ({ children, className = '' }) => {
  if (!children) return null;
  return (
    <p
      role="alert"
      data-testid="field-error"
      className={`mt-1.5 text-xs sm:text-[13px] text-red-600 font-semibold flex items-center gap-1 ${className}`}
    >
      <span aria-hidden>&#9888;</span>
      <span>{children}</span>
    </p>
  );
};

export default FieldError;
